module.exports = __webpack_public_path__ + "assets/img/block-0fd3dff8.png";